import { $generateNodesFromDOM } from '@lexical/html'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getRoot } from 'lexical'
import MarkdownIt from 'markdown-it'
import { useEffect } from 'react'

export const md = new MarkdownIt()
export const lexicalState = {
  fullMarkdown: ''
}

function unwrapImageTag(dom: Document) {
  const imgs = dom.querySelectorAll('p > img')
  for (const img of imgs) {
    const paragraph = img.parentNode!
    paragraph!.parentNode!.replaceChild(img, paragraph)
  }
  return dom
}

export function UpdateContentPlugin({
  markdown,
  containerRef
}: {
  markdown: string
  containerRef: React.RefObject<HTMLDivElement>
}) {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    lexicalState.fullMarkdown = markdown
    const html = md.render(markdown)
    const parser = new DOMParser()
    const dom = parser.parseFromString(html, 'text/html')
    unwrapImageTag(dom)

    editor.update(() => {
      const nodes = $generateNodesFromDOM(editor, dom)
      const root = $getRoot()
      root.clear()
      root.append(...nodes)
      const firstChild = containerRef.current?.firstChild as HTMLElement
      if (firstChild) {
        requestAnimationFrame(() => {
          firstChild.scrollTop = 0
        })
      }
    })
  }, [markdown, editor])
  return null
}
